<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Grader Aktif
      <router-link 
      to="/user-manajemen/user-grader-tambah" 
      class="btn btn-success ml-auto">
        Tambah
      </router-link>

    </CCardHeader>

      <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/user-manajemen/user-grader"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          style="background-color:#486ba7"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true">Aktif
          <span class="badge ml-1 badge-success text-white">0</span></router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/user-manajemen/user-grader-tidak-aktif"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false" >Tidak Aktif
          <span class="badge ml-1 badge-danger text-white">0</span></router-link>
      </li>
    </ul>
    <!-- Tabs End -->

    <div class="card-body">
      <div class="row">
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            :options="[10,25,100,'Semua Data']"/>

          <CInput label="Pencarian" class="float-right" placeholder="Cari Data .." v-model="search" />
        </CCol>
      </div>

      <div class="row">
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>

            <template #no="{index}">
              <td class="py-2">{{ indexed == 0 ? index + 1 : index + indexed + 1  }}</td>
            </template>
            <template #email="{item}">
              <td class="py-2">{{ item.email ? item.email : '-' }}</td>
            </template>
            <template #username="{item}">
              <td class="py-2">{{ item.username ? item.username : '-' }}</td>
            </template>
            <template #noTelp="{item}">
              <td class="py-2">{{ item.noTelp ? item.noTelp : '-' }}</td>
            </template>
            <template #bank="{item}">
              <td class="py-2">{{ item.bank ? item.bank : '-' }}</td>
            </template>
            <template #noRekening="{item}">
              <td class="py-2">{{ item.noRekening ? item.noRekening : '-' }}</td>
            </template>
            <template #npwp="{item}">
              <td class="py-2">{{ item.npwp ? item.npwp : '-' }}</td>
            </template>
            <template #instansi="{item}">
              <td class="py-2">{{ item.instansi ? item.instansi : '-' }}</td>
            </template>
            
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <router-link :to="'/sertifikasi/user-grader-edit/' + item.id" class="mr-2">
                  <CButton v-c-tooltip="'Ubah'" color="info" square class="btn-sm mr-1">
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>
                <CButton v-c-tooltip="'Hapus'" color="danger" square class="btn-sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>

          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @change="pageChange"
          />
        </CCol>
      </div>
    </div>
  </CCard>
</template>
<script>
import UserGraderService from "../../../services/sertifikasi/user-grader.service";
import { Pagination } from "../../../mixins/Pagination";
const fields = [
  { key: "no" },
  { key: "name", label: "Nama" },
  { key: "username" },
  { key: "email" },
  { key: "instansi" },
  { key: "noTelp", label: "Nomor Telepon" },
  { key: "bank", label: "Bank" },
  { key: "noRekening", label: "No. Rekening" },
  { key: "npwp", label: "NPWP" },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:10%; text-align: center" }
];

export default {
  mixins : [Pagination],
  name: "UserGrader",
  data() {
    return {
      items: [],
      actionPost: "",
      formData: {
        nama: "",
        email: "",
        no_telephone: "",
        tipe_petugas: "",
        kota: "",
        username: "",
        dibuat_pada: "",
        id: ""
      },
      fields,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getData(this.currentPage,this.pageSize,this.search)
  },
  methods: {
    pageChange() {
      this.getData(this.currentPage,this.pageSize,this.search)
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            UserGraderService.deleteUserGrader(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertSuccess();
                this.getData(this.currentPage,this.pageSize,this.search)
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(currentPage,pageSize,filter) {
        let loader = this.$loading.show({
            container: false ? null : this.$refs.formContainer,
            canCancel: true,
            onCancel: this.onCancel
        });
        UserGraderService.getUserGrader(currentPage,pageSize,filter)
        .then(response => {
            // comment console console.log(response.data.data.content);
            this.items = response.data.data.content;
            this.pagination.totalPages = response.data.data.totalPages;
            this.currentPage = response.data.data.pageable.pageNumber + 1;
            setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
            // comment console console.log(error);
        });
    }
  }
};
</script>